import React from 'react';
import styled from 'styled-components';
import { TrevorComponent, TrevorIcon } from '@trevor/ui-components';

const CloseIcon = styled(TrevorIcon).attrs({
  name: 'close',
  size: 12,
})`
  color: #1f2937;
  cursor: pointer;
  margin: 4px;
`;

export type CopiedNotificationProps = {
  onClose: F0;
};

const CopiedNotification: TrevorComponent<CopiedNotificationProps> = ({
  className,
  onClose,
}) => {
  return (
    <div className={className}>
      <TrevorIcon name="ok" size="md" />
      <span>Link copied to clipboard</span>
      <CloseIcon onClick={onClose} />
    </div>
  );
};

export default styled(CopiedNotification)<{ $isShown: boolean }>`
  width: 100%;
  position: absolute;
  background: #d1fae5;
  padding: 12px;
  box-shadow: 0 1px 1.41px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  top: 36px;
  left: 0;
  display: ${(p) => (p.$isShown ? 'flex' : 'none')};
  flex-direction: row;
  align-items: center;

  & > span {
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
    margin-right: auto;
  }
`;
